<script>
import Layout from "../_layouts/main";
import PageHeader from "@/components/page-header";
import List from '../../components/report/settlement-daily'

/**
 * Dashboard Component
 */
export default {
  components: {
    Layout,
    PageHeader,
    List
  },
  data() {
    return {
      title: "",
      state: ''
    };
  },
  mounted() {
    this.title = this.$t('일별 정산')
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <List :user="''" />
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
